import { render, staticRenderFns } from "./companies-results.vue?vue&type=template&id=4f0f5ea7&lang=html&"
import script from "./companies-results.vue?vue&type=script&lang=js&"
export * from "./companies-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports